export default function slashme() {
  return function link(message, name) {
    if (message && message.indexOf('/me ') === 0) {
      return message.replace('/me ', `${name} `);
    }

    return message;
  };
}
